<div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
  <div class="bfx-input-label">
    <p-checkbox
      [bfxInputLabelOnClick]="chkBoxLabel"
      class="icd__base__checkbox bfx-checkbox-enable-control"
      binary="true"
      [disabled]="auxCheckbox.locked || disabled || locked || auxCheckbox.permanentLock"
      [(ngModel)]="auxCheckbox.value"
      (onChange)="onAuxCheckboxChange()"
      [style.display]="auxCheckbox.enabled ? 'flex' : 'none'"
    ></p-checkbox>
    <div [ngClass]="inputDirective.labelClasses" #chkBoxLabel>{{ label }}</div>
  </div>
</div>

<!-- INPUT -->
<div
  [ngClass]="{
    'icd__clock__container': true,
    'bfx-field': true,
    'bfx-field-sm-subtle': true,
    'bfx-field-enabled-subtle': !(disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)),
    'bfx-field-disabled-subtle': disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value),
    'bfx-field-invalid-subtle': data.state == 1 && !locked
  }"
>
  <bfx-inputMask
    #inputField
    [(ngModel)]="data.timeValue"
    (onBlur)="onBlur($event)"
    (onFocus)="onFocus($event)"
    [mask]="config.mask"
    [placeholder]="config.default"
    [disabled]="disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)"
    [autoClear]="false"
    class="icd__clock__input"
    [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
    tooltipPosition="top"
    tooltipStyleClass="bfx-tooltip-negative-bold"
    [styleClass]="{
      'bfx-field-text': true,
      'bfx-field-inputted-sm-subtle': true,
      'bfx-field-inputted-enabled-subtle': !(disabled || data.disabled || locked),
      'bfx-field-inputted-disabled-subtle': disabled || data.disabled || locked,
      'bfx-field-inputted-invalid-subtle': data.state == 1 && !locked
    }"
  >
  </bfx-inputMask>
</div>
